import reducers from './reducers'

export { default as flagsTypes } from './types'
export { default as flagsActions } from './actions'
export { default as flagsSelectors } from './selectors'

export default reducers
